





































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TbReport,TbOrderPad,TbReturnOrder } from "@/http";
import { calendarPanel, NumberKeyboard } from "@/components";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { fmoney } from "@/common/util/money";
import calculate from "@/common/util/calculate";
import detail from "./detail.vue";
dayjs.locale("zh-cn");
@Component({
  components: {
    calendarPanel,
    NumberKeyboard,
    detail,
  },
})
export default class salebb extends Vue {
  public $refs: {
    detail: HTMLFormElement;
    calendar1: HTMLFormElement;
    barcode:HTMLFormElement;
  };
  @Prop({
      default:''
  })
  start:string;
  @Prop({
      default:''
  })
  end:string;
  @Prop({
      default:'1'
  })
  curZLStr:string;
  @Prop({
      default:''
  })
  id:string;
  @Prop({
      default:''
  })
  orderStatusStr:string;
  curZL = 1;
  fmoney = fmoney;
  /**查询项- */
  searchValue1 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    orderNo: "",
    memberPhone: "",
    paymentMethod: null,
    orderType: 1,
    startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    consumptionStart: "",
    consumptionEnd: "",
    sortType: 1,
    sortValue: 2,
    skip: 0,
    count: 10,
  };
  searchValue2 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    orderNo: "",
    memberPhone: "",
    returnType: null,
    orderType: 2,
    startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    creditedStartTime: "",
    creditedEndTime: "",
    sortType: 1,
    sortValue: 2,
    skip: 0,
    count: 10,
  };
  //异常销售订单
  searchValue3 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    key2: "",
    type:6,
    paymentMethod: null,
    start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    skip: 0,
    count: 10,
    orderStatus:1,
  };
  //异常退货订单
  searchValue4 = {
    key: "",
    returnOrderNo: "",
    start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    status:null,
    skip: 0,
    count: 10,
    refundType:null,
  };
  /**时间类型下拉 */
  showStatusPopover = false;
  payType = null;
  payOptions = [
    {
      label: "全部支付方式",
      value: null,
    },
    {
      label: "会员卡支付",
      value: 1,
    },
    {
      label: "现金支付",
      value: 2,
    },
    {
      label: "微信支付",
      value: 3,
    },
    {
      label: "支付宝支付",
      value: 4,
    },
    {
      label: "现金+会员卡+微信",
      value: 5,
    },
    {
      label: "现金+会员卡+支付宝",
      value: 6,
    },
    {
      label: "现金+微信",
      value: 7,
    },
    {
      label: "现金+支付宝",
      value: 8,
    },
    {
      label: "会员卡+微信",
      value: 9,
    },
    {
      label: "会员卡+支付宝",
      value: 10,
    },
    {
      label: "现金+会员卡",
      value: 11,
    },
    {
      label: "线下微信",
      value: 13,
    },
    {
      label: "线下支付宝",
      value: 14,
    },
    {
      label: "现金+线下支付宝",
      value: 15,
    },
    {
      label: "会员卡+线下支付宝",
      value: 16,
    },
    {
      label: "现金+线下微信",
      value: 17,
    },
    {
      label: "会员卡+线下微信",
      value: 18,
    },
    {
      label: "线下微信+线下支付宝",
      value: 19,
    },
    {
      label: "现金+会员卡+线下支付宝",
      value: 20,
    },
    {
      label: "现金+会员卡+线下微信",
      value: 21,
    },
    {
      label: "现金+线下支付宝+线下微信",
      value: 22,
    },
    {
      label: "会员卡+线下支付宝+线下微信",
      value: 23,

    },
    {
      label: "会员卡+线下支付宝+线下微信+现金",
      value: 24,
    },
  ];
  payOptions2 = [
    {
      label: "全部退款方式",
      value: null,
    },
    {
      label: "现金",
      value: 1,
    },
    {
      label: "会员卡",
      value: 2,
    },
    {
      label: "现金+会员卡",
      value: 3,
    },
    {
      label: "微信",
      value: 4,
    },
    {
      label: "支付宝",
      value: 5,
    },
    {
      label: "线下微信",
      value: 6,
    },
    {
      label: "线下支付宝",
      value: 7,
    },
    {
      label: "线下微信+现金",
      value: 8,
    },
    {
      label: "线下微信+会员卡",
      value: 9,
    },
    {
      label: "线下微信+现金+会员卡",
      value: 10,
    },
    {
      label: "线下支付宝+现金",
      value: 11,
    },
    {
      label: "线下支付宝+会员卡",
      value: 12,
    },
    {
      label: "线下支付宝+现金+会员卡",
      value: 13,
    },
    {
      label: "线下支付宝+现金+会员卡+线下微信",
      value: 14,
    },
    {
      label: "线下支付宝+会员卡+线下微信",
      value: 15,
    },
    {
      label: "线下支付宝+现金+线下微信",
      value: 16,
    },
    {
      label: "线下支付宝+线下微信",
      value: 17,
    },
  ];
  payOptions3 = [
    {
      label: "全部支付方式",
      value: null,
    },
    {
      label: "微信支付",
      value: 3,
    },
    {
      label: "支付宝支付",
      value: 4,
    },
    {
      label: "会员卡支付",
      value: 1,
    },
    {
      label: "现金支付",
      value: 2,
    },
  ];
  payOptions4 = [
    {
      label: "全部退款方式",
      value: null,
    },
    {
      label: "微信支付",
      value: 1,
    },
    {
      label: "支付宝支付",
      value: 2,
    },
  ];
  /**退货订单时间状态下拉 */
  showthTimePopover = false;
  thTimeType = 1;
  thTimeOptions = [
    {
      label: "退货时间",
      value: 1,
    },
    {
      label: "退款到账时间",
      value: 2,
    },
  ];
  //异常退货状态
  thTimeType2 = null;
  thTimeOptions2 = [
    {
      label: "全部状态",
      value: null,
    },
    {
      label: "退款中",
      value: 1,
    },
    {
      label: "退款失败",
      value: 3,
    },
    {
      label: "退款关闭",
      value: 4,
    },
  ];

  /**支付状态下拉 */
  showzfStatusPopover = false;
  payStatusType = 1;
  payStatusOptions = [
    {
      label: "支付状态",
      value: null,
    },
    {
      label: "待支付",
      value: 1,
    },
    {
      label: "支付失败",
      value: 3,
    },
    {
      label: "已关闭",
      value: 4,
    },
  ];

  /**时间控件 */
  pickerShow = false;
  startDate = dayjs(new Date()).format("YYYY-MM-DD");
  endDate = dayjs(new Date()).format("YYYY-MM-DD");

  /**列表展示
   * 1:图
   * 2：表格
   */
  showType = 1;

  userInfo: any = {};

  /**列表加载相关 */
  refreshing = false;
  loading = false;
  finished = false;
  list = [];
  list2 = [];
  list3 = [];
  list4 = [];
  total = 0;
  currentPage = 1;
  totalStock = 0;

  timeActive = null;
  hj_ze = "0.00";
  hj_xsnum = 0;
  hj_the = "0.00";
  hj_sxze = "0.00";
  hj_zkze = "0.00";

  hj_xjnovip = "0.00";
  hj_xj = "0.00";
  hj_cash = "0.00";
  hj_wechat = "0.00";
  hj_alipay = "0.00";
  hj_vipcard = "0.00";
  hj3_ze = "0.00";
  hj3_sxze = "0.00";
  hj3_czze = "0.00";
  iscz = false;
  totalrefundNum = 0;
  totalrefundTotal = '0.00';


  get getPayStatus() {
    let str = "";
    str = this.payOptions.find((v) => v.value == this.payType).label;
    return str;
  }
  get getPayStatus2() {
    let str = "";
    str = this.payOptions2.find((v) => v.value == this.payType).label;
    return str;
  }
  get getPayStatus4() {
    let str = "";
    str = this.payOptions4.find((v) => v.value == this.payType).label;
    return str;
  }
  get getthTimeStatus(){
    let str = "";
    str = this.thTimeOptions.find((v) => v.value == this.thTimeType).label;
    return str;
  }
  get getthTimeStatus2(){
    let str = "";
    str = this.thTimeOptions2.find((v) => v.value == this.thTimeType2).label;
    return str;
  }
  get getPayStatus3() {
    let str = "";
    str = this.payOptions3.find((v) => v.value == this.payType).label;
    return str;
  }
  get getzfPayStatus() {
    let str = "";
    str = this.payStatusOptions.find((v) => v.value == this.payStatusType).label;
    return str;
  }

  @Watch("searchValue1.orderNo")
  nameChange(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  @Watch("searchValue1.memberPhone")
  nameChange2(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  @Watch("searchValue2.orderNo")
  nameChange3(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  @Watch("searchValue2.memberPhone")
  nameChange4(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  @Watch("searchValue3.key2")
  nameChange5(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  @Watch("searchValue4.returnOrderNo")
  nameChange6(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  @Watch("searchValue4.key")
  nameChange7(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  created() {
    if(this.curZLStr){
		  this.curZL=Number(this.curZLStr);
	  }
    if(this.orderStatusStr){
      const val = Number(this.orderStatusStr);
      if(val==0){
        /** 全部支付状态 */
        this.payStatusType = null;
        this.searchValue3.orderStatus = null;
      }else{
        this.payStatusType = val;
        this.searchValue3.orderStatus = val;
      }
    }
	  if(this.start){
		  if(this.curZL==1){
			  this.searchValue1.startTime = this.start;
			  this.searchValue1.endTime = this.end;
		  }else if(this.curZL==2){
			  this.searchValue2.startTime = this.start;
			  this.searchValue2.endTime = this.end;
		  }
	  	this.startDate = dayjs(this.start).format("YYYY-MM-DD");
	  	this.endDate = dayjs(this.end).format("YYYY-MM-DD");
	  }
  }

  async mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    if(this.id&&this.curZL==3){
      this.viewdetail3(this.id);
    }
    this.getInputFocus()

    document.addEventListener('click',this.chargeInputFocus)

  }

  async scanInput(val){
        if(this.curZL==1){
          this.searchValue1.orderNo=val;
        }else if(this.curZL==2){
          this.searchValue2.orderNo=val;
        }
    }
    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }
    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input') {
          this.getInputFocus()

        }
    }
    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        if(this.isFocus){

        }else{

          if (event.key === 'Enter' || event.keyCode == 13) {
              let code = this.scanCodes?this.scanCodes:event.target.value
              this.scanInput(code)
              this.scanCodes = ''
          return
          }
        }

    }
    isFocus = false
    getFocus(){
        this.isFocus = true
    }
    inputBlur(){
        this.isFocus = false
        document.addEventListener('click',this.chargeInputFocus)

    }
  chooseZL(tag) {
    this.curZL = tag;
    this.clearSearch();
    this.iscz = false;
    this.getList();
  }
  clearSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          orderNo: "",
          memberPhone: "",
          paymentMethod: null,
          orderType: 1,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          consumptionStart: "",
          consumptionEnd: "",
          sortType: 1,
          sortValue: 2,
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          orderNo: "",
          memberPhone: "",
          returnType: null,
          orderType: 2,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          creditedStartTime: "",
          creditedEndTime: "",
          sortType: 1,
          sortValue: 2,
          skip: 0,
          count: 10,
        };
        break;
      case 3:
        this.searchValue3 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          key2: "",
          type:6,
          paymentMethod: null,
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
          orderStatus:1,
        };
        break;
      case 4:
        this.searchValue4 = {
          key: "",
          returnOrderNo: "",
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          status:null,
          skip: 0,
          count: 10,
          refundType:null
        };
        break;
      default:
        break;
    }
    this.payType = null;
    this.searchValue1.paymentMethod = null;
    this.searchValue2.returnType = null;
    this.payStatusType = 1;
    this.searchValue3.paymentMethod = null;
    this.searchValue3.orderStatus = 1;
    this.timeActive = null;
    this.startDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.thTimeType = 1;
    this.thTimeType2 = null;
  }

  openselDate() {
    this.pickerShow = true;
  }
  /**确定选择时间 */
  onselConfirm(date) {
    const [start, end] = date;
    this.startDate = dayjs(start).format("YYYY-MM-DD");
    this.endDate = dayjs(end).format("YYYY-MM-DD");

    this.pickerShow = false;
    this.timeActive = null;
    this.setTimeSearch();
  }
  closeTime() {
    this.pickerShow = false;
  }

  /**下拉刷新 */
  onRefresh() {
    // 清空列表数据
    this.finished = false;
    // 重新加载数据
    // 将 loading 设置为 true，表示处于加载状态
    this.loading = true;
    let arg2 =
      this.curZL == 1
        ? "list"
        : this.curZL == 2
        ? "list2"
        : this.curZL == 3
        ? "list3"
        : this.curZL == 4
        ? "list4"
        : "list";
    this[arg2] = [];
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        : this.curZL == 3
        ? "searchValue3"
        : this.curZL == 4
        ? "searchValue4"
        :"searchValue1";
    this[arg].skip = 0;
    this[arg].count = 10;
    this.total = 0;
    this.currentPage = 1;
    this.loadMore();
  }
  /**触底加载 */
  async loadMore() {
      let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        : this.curZL == 3
        ? "searchValue3"
        : this.curZL == 4
        ? "searchValue4"
        : "searchValue1";
    let arg2 =
      this.curZL == 1
        ? "list"
        : this.curZL == 2
        ? "list2"
        : this.curZL == 3
        ? "list3"
        : this.curZL == 4
        ? "list4"
        : "list";
    if (this.refreshing) {
      this[arg2] = [];
      this.refreshing = false;
    }
    let s = this[arg].count;
    this.$nextTick(async ()=>{
      switch (this.curZL) {
      // 销售订单
      case 1:
        let resjy = await TbReport.GetTbSaleReportList(Object.assign({}, this[arg]));
        let resjy2 = await TbReport.GetTbSaleReportTotal(Object.assign({}, this[arg]));
        this.list =
          this[arg].skip == 0
            ? resjy.items.map((v) => {
                return {
                  ...v,
                  orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                };
              })
            : this.list.concat(
                resjy.items.map((v) => {
                  return {
                    ...v,
                    orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                  };
                })
              );
        this.total = resjy.totalCount;
        this.hj_ze = resjy2.count;
        this.hj_xsnum = resjy2.num;
        // this.hj_the = fmoney(resjy2.returnAmount, 2);
        this.hj_sxze = fmoney(resjy2.receivables, 2);
        this.hj_zkze = fmoney(resjy2.totalDiscountPrice, 2);
        this.iscz = false;
        break;
      // 退货订单
      case 2:
        let reszf = await TbReport.GetTbSaleReportList(Object.assign({}, this[arg]));
        let reszf2 = await TbReport.GetTbSaleReportTotal(Object.assign({}, this[arg]));
        this.list2 =
          this[arg].skip == 0
            ? reszf.items.map((v) => {
                return {
                  ...v,
                  orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                };
              })
            : this.list2.concat(
                reszf.items.map((v) => {
                  return {
                    ...v,
                    orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                  };
                })
              );
        this.total = reszf.totalCount;
        this.hj_xjnovip = reszf2.count;
        this.hj_xj = reszf2.num;
        this.hj_cash = fmoney(reszf2.totalRefunded, 2);
        this.iscz = false;
        break;
      // 异常销售订单
      case 3:
        let resyc = await TbOrderPad.GetAbnormalOrderListAsync(Object.assign({}, this[arg]));
        this.list3 =
          this[arg].skip == 0
            ? resyc.items.map((v) => {
                return {
                  ...v,
                  orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                };
              })
            : this.list3.concat(
                resyc.items.map((v) => {
                  return {
                    ...v,
                    orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                  };
                })
              );
        this.total = resyc.totalCount;
        this.iscz = false;
        break;
      //异常退货单
      case 4:
        let resth = await TbReturnOrder.GetAbnormalTbReturnOrderList(Object.assign({}, this[arg]));
        let resth2 = await TbReturnOrder.GetAbnormalTbReturnOrderTotal(Object.assign({}, this[arg]));
        this.list4 =
          this[arg].skip == 0
            ? resth.items.map((v) => {
                return {
                  ...v,
                  createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
                };
              })
            : this.list4.concat(
                resth.items.map((v) => {
                  return {
                    ...v,
                    createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
                  };
                })
              );
        this.total = resth.totalCount;
        this.totalrefundNum = resth2.refundNum;
        this.totalrefundTotal = fmoney(resth2.refundTotal, 2);
        this.iscz = false;
        break;
      default:
        break;
    }
    this.currentPage++;
    this[arg].skip = (this.currentPage - 1) * s;
    this.loading = false;
    if (this[arg2].length >= this.total) {
      this.finished = true;
    }
    })
  }
  /**获取商品列表 */
  async getList() {
    // this.onRefresh();
    // return;
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        : this.curZL == 3
        ? "searchValue3"
        : this.curZL == 4
        ? "searchValue4"
        :"searchValue1";
    this[arg].skip = 0;
    this[arg].count = 10;
    this.currentPage = 1;
    let arg2 =
      this.curZL == 1
        ? "list"
        : this.curZL == 2
        ? "list2"
        : this.curZL == 3
        ? "list3"
        : this.curZL == 4
        ? "list4"
        : "list";
    this[arg2] = [];
    this.total = 0;
    switch (this.curZL) {
      // 销售订单
      case 1:
        let resjy = await TbReport.GetTbSaleReportList(Object.assign({}, this[arg]));
        let resjy2 = await TbReport.GetTbSaleReportTotal(Object.assign({}, this[arg]));
        this.list = resjy.items.map((v) => {
                      return {
                        ...v,
                        orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                      };
                    })
        this.total = resjy.totalCount;
        this.hj_ze = resjy2.count;
        this.hj_xsnum = resjy2.num;
        this.hj_sxze = fmoney(resjy2.receivables, 2);
        this.hj_zkze = fmoney(resjy2.totalDiscountPrice, 2);
        this.iscz = false;
        this.finished = false;
        break;
      // 退货订单
      case 2:
        let reszf = await TbReport.GetTbSaleReportList(Object.assign({}, this[arg]));
        let reszf2 = await TbReport.GetTbSaleReportTotal(Object.assign({}, this[arg]));
        this.list2 = reszf.items.map((v) => {
                      return {
                        ...v,
                        orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                      };
                    })
        this.total = reszf.totalCount;
        this.hj_xjnovip = reszf2.count;
        this.hj_xj = reszf2.num;
        this.hj_cash = fmoney(reszf2.totalRefunded, 2);
        this.iscz = false;
        this.finished = false;
        break;
      // 异常销售订单
      case 3:
        let resyc = await TbOrderPad.GetAbnormalOrderListAsync(Object.assign({}, this[arg]));
        this.list3 = resyc.items.map((v) => {
                        return {
                          ...v,
                          orderDate: dayjs(v.orderDate).format("YYYY-MM-DD"),
                        };
                      })
        this.total = resyc.totalCount;
        this.iscz = false;
        this.finished = false;
        break;
      //异常退货单
      case 4:
        let resth = await TbReturnOrder.GetAbnormalTbReturnOrderList(Object.assign({}, this[arg]));
        let resth2 = await TbReturnOrder.GetAbnormalTbReturnOrderTotal(Object.assign({}, this[arg]));
        this.list4 = resth.items.map((v) => {
                        return {
                          ...v,
                          createTime: dayjs(v.createTime).format("YYYY-MM-DD"),
                        };
                      })
        this.total = resth.totalCount;
        this.totalrefundNum = resth2.refundNum;
        this.totalrefundTotal = fmoney(resth2.refundTotal, 2);
        this.iscz = false;
        this.finished = false;
        break;
      default:
        break;
    }

  }
  /**重置 */
  resetSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          orderNo: "",
          memberPhone: "",
          paymentMethod: null,
          orderType: 1,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          consumptionStart: "",
          consumptionEnd: "",
          sortType: 1,
          sortValue: 2,
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          orderNo: "",
          memberPhone: "",
          returnType: null,
          orderType: 2,
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          creditedStartTime: "",
          creditedEndTime: "",
          sortType: 1,
          sortValue: 2,
          skip: 0,
          count: 10,
        };
        break;
      case 3:
        this.searchValue3 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          key2: "",
          type:6,
          paymentMethod: null,
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
          orderStatus:1,
        };
        break;
      case 4:
        this.searchValue4 = {
          key: "",
          returnOrderNo: "",
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          status:null,
          skip: 0,
          count: 10,
          refundType:null
        };
        break;
      default:
        break;
    }
    this.payType = null;
    this.searchValue1.paymentMethod = null;
    this.searchValue2.returnType = null;
    this.payStatusType = 1;
    this.searchValue3.paymentMethod = null;
    this.searchValue3.orderStatus = 1;
    this.timeActive = null;
    this.startDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.thTimeType = 1;
    this.thTimeType2 = null;
    console.log(1);
    this.iscz = true;
    this.getList();

  }
  async sortFun(val) {
    if (this.curZL == 1) {
      switch (val) {
        case 1:
          this.searchValue1.sortType = 1;
          break;
        case 2:
          this.searchValue1.sortType = 2;
          break;
        case 3:
          this.searchValue1.sortType = 3;
          break;
        case 4:
          this.searchValue1.sortType = 4;
          break;
        case 5:
          this.searchValue1.sortType = 5;
          break;
        case 6:
          this.searchValue1.sortType = 6;
          break;
        case 7:
          this.searchValue1.sortType = 7;
          break;
        case 8:
          this.searchValue1.sortType = 8;
          break;
        default:
          break;
      }
      this.searchValue1.sortValue = this.searchValue1.sortValue == 2 ? 1 : 2;
    }
    this.iscz = false;
    await this.getList();
  }
  changeTimeStatusXL(item, index) {
    this.payType = item.value;
    if (this.curZL == 1) {
      this.searchValue1.paymentMethod = this.payType;
    }
    if (this.curZL == 2) {
      this.searchValue2.returnType = this.payType;
    }
    if (this.curZL == 3) {
      this.searchValue3.paymentMethod = this.payType;
    }
    if (this.curZL == 4) {
      this.searchValue4.refundType = this.payType;
    }
    this.showStatusPopover = false;
    this.setTimeSearch();
  }
  //退货订单时间的选择
  changethTimeXL(item, index) {
    this.thTimeType = item.value;
    this.showthTimePopover = false;
    this.setTimeSearch();
  }
  changethTimeXL2(item, index) {
    this.thTimeType2 = item.value;
    this.searchValue4.status = this.thTimeType2;
    this.showthTimePopover = false;
    this.setTimeSearch();
  }
  //改变支付状态
  changezfStatusXL(item, index){
    this.payStatusType = item.value;
    if (this.curZL == 3) {
      this.searchValue3.orderStatus = this.payStatusType;
    }
    this.showzfStatusPopover = false;
    this.setTimeSearch();
  }
  async chooseTime(type) {
    this.timeActive = type;
    // 获取当前日期
    const today = dayjs();
    const firstDayOfWeek = dayjs().startOf("week");
    const firstDayOfMonth = dayjs().startOf("month");
    const prevMonthStart = today.subtract(1, "month").startOf("month");
    const prevMonthEnd = today.subtract(1, "month").endOf("month");
    switch (type) {
      case 1:
        this.startDate = today.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 2:
        this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 3:
        this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 4:
        this.startDate = prevMonthStart.format("YYYY-MM-DD");
        this.endDate = prevMonthEnd.format("YYYY-MM-DD");
        break;

      default:
        break;
    }
    await this.setTimeSearch();
  }
  async setTimeSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1.startTime = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue1.endTime = this.endDate ? this.endDate + " 23:59:59" : "";
        this.searchValue1.consumptionStart = "";
        this.searchValue1.consumptionEnd = "";
        break;
      case 2:
        this.searchValue2.startTime = '';
        this.searchValue2.endTime = '';
        this.searchValue2.creditedStartTime = '';
        this.searchValue2.creditedEndTime = '';
        if(this.thTimeType==1) {
          this.searchValue2.startTime = this.startDate ? this.startDate + " 00:00:00" : "";
          this.searchValue2.endTime = this.endDate ? this.endDate + " 23:59:59" : "";
        }else{
          this.searchValue2.creditedStartTime = this.startDate ? this.startDate + " 00:00:00" : "";
          this.searchValue2.creditedEndTime = this.endDate ? this.endDate + " 23:59:59" : "";
        }
        break;
      case 3:
        this.searchValue3.start = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue3.end = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      case 4:
        this.searchValue4.start = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue4.end = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      default:
        break;
    }
    this.iscz = false;
    await this.getList();
  }
  viewdetail(id) {
    this.$refs.detail.showFun(id, 1);
  }
  viewdetail2(id) {
    this.$refs.detail.showFun(id, 2);
  }
  viewdetail3(id) {
    this.$refs.detail.showFun(id, 3);
  }
  viewdetail4(id) {
    this.$refs.detail.showFun(id, 4);
  }
  getThstatus(val){
    let str = "";
    str = this.thTimeOptions2.find((v) => v.value == val).label;
    return str;
  }
  getThtype(val){
    let str = "";
    str = this.payOptions2.find((v) => v.value == val).label;
    return str;
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/report/components/salebb.vue